import React from 'react'
import { Button, Popup } from 'semantic-ui-react'

/*
 * @param {object} props
 * @param {(IntegrationSetting) => void} props.activateIntegration
 * @param {(IntegrationSetting) => void} props.deactivateIntegration
 * @param {boolean} props.loading
 * @param {boolean} props.isAuthenticated
 * @param {boolean} props.isIntegrationActive
 * @param {string} props.integrationType
 * @param {string=} props.position
 */
export default function ActivateIntegrationButtonSection({
  activateIntegration,
  deactivateIntegration,
  deleteIntegration,
  hideDeleteButton = true,
  loading,
  isAuthenticated,
  isIntegrationActive,
  integrationType,
  position,
}) {
  if (!isAuthenticated) {
    return (
      <Popup
        basic
        wide
        position={position || 'top left'}
        trigger={
          <div>
            <button className="ui primary button" disabled>
              Activate integration
            </button>
          </div>
        }
      >
        You need to authenticate with {integrationType} before enabling any integrations.
      </Popup>
    )
  }

  if (isIntegrationActive) {
    return (
      <Button onClick={deactivateIntegration} loading={loading} disabled={loading}>
        Deactivate integration
      </Button>
    )
  } else {
    return (
      <React.Fragment>
        <Button onClick={activateIntegration} loading={loading} disabled={loading}>
          Activate integration
        </Button>
        {!hideDeleteButton && (
          <Button basic negative onClick={deleteIntegration} loading={loading} disabled={loading}>
            Reset integration
          </Button>
        )}
      </React.Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/ActivateIntegrationButtonSection/index.js